export default __webpack_public_path__ + "2bc0fc708fd967911f202e3f90c076ad.png";